export const hashify = hash => hash
  .toLowerCase()
  .replace(/[`’'"]/gmi, '')
  .replace(/[\W]+$/mi, '')
  .replace(/_+$/mi, '')
  .replace(/[\W]+/gmi, '-')
  .replace(/_+/gmi, '-');
